import Layout from '@/layout';
var missionRouter = {
  path: '/mission',
  component: Layout,
  redirect: '/mission/list',
  name: 'mission',
  meta: {
    title: '任务',
    icon: 'mission'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/mission/list');
    },
    name: 'missionList',
    meta: {
      title: '任务数据',
      icon: 'mission'
    }
  }]
};
export default missionRouter;